export default {
  path: "/admin",
  component: () => import("@/layouts/main.vue"),
  redirect: { name: "admin-analytics" },
  meta: {
    authRequired: true,
        verificationRequired: true,
        roles : ["administrator", "admin"]
  },
  children: [
    {
      path: "analytics",
      name: "admin-analytics",
      meta: {
        title: "Analitik",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/analytics/index.vue"),
    },
    {
      path: "chat-analytics",
      name: "admin-chat-analytics",
      meta: {
        title: "Statistik Komplain",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/chat-analytics/index.vue"),
    },
    {
      path: "rtlh",
      name: "admin-rtlh",
      meta: {
        title: "Data RTLH",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/rtlh/index.vue"),
    },
    {
      path: "vendor-flagging",
      name: "admin-vendor-flagging",
      meta: {
        title: "Flagging Vendor & Anggaran",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/vendor-flagging/index.vue"),
    },
    {
      path: "vendor",
      name: "admin-vendor-account",
      meta: {
        title: "Manajemen Akun Vendor",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/vendor/index.vue"),
    },
    {
      path: "vendor/:id/detail",
      name: "admin-vendor-account-detail",
      meta: {
        title: "Detail Akun Vendor",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/vendor/detail.vue"),
    },
    {
      path: "vendor/create",
      name: "admin-vendor-account-create",
      meta: {
        title: "Tambah Akun Vendor",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/vendor/create.vue"),
    },
    {
      path: "vendor/update/:id",
      name: "admin-vendor-account-update",
      meta: {
        title: "Edit Akun Vendor",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/vendor/update.vue"),
    },
    {
      path: "vendor-finalisasi",
      name: "admin-vendor-finalisasi",
      meta: {
        title: "Validasi Finalisasi Vendor",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/vendor-finalisasi/index.vue"),
    },
    {
      path: "rtlh-validation-data",
      name: "admin-rtlh-validation-data",
      meta: {
        title: "Validasi data RTLH",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/rtlh-validation-data/index.vue"),
    },
    {
      path: "news",
      name: "admin-news",
      meta: {
        title: "Berita",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/news/index.vue"),
    },
    {
      path: "kebijakan-privasi",
      name: "admin-kebijakan-privasi",
      meta: {
        title: "Kebijakan Privasi",
        authRequired: true,
      },
      component: () => import("../views/custom/admin/kebijakan-privasi/index.vue"),
    },
  ],
};
